import type { FC } from "react"

import { formatNumber } from "@/utils/number"

interface InventoryAdjustmentHistoryTotalQtyChangeCellProps {
  qtyChange: number
}

export const InventoryAdjustmentHistoryTotalQtyChangeCell: FC<InventoryAdjustmentHistoryTotalQtyChangeCellProps> = ({
  qtyChange,
}) => {
  const formatted = formatNumber(qtyChange, 2, 2)
  if (qtyChange > 0) {
    return <span className='font-medium text-green-600'>+{formatted}</span>
  }
  if (qtyChange < 0) {
    return <span className='font-medium text-red-600'>{formatted}</span>
  }
  return <span className='text-gray-700'>{formatted}</span>
}
